var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.$t("Error"),
        "header-bg-variant": "warning",
        "header-text-variant": "dark",
        "ok-only": "",
      },
      on: {
        ok: function ($event) {
          return _vm.errors.shift()
        },
      },
      model: {
        value: _vm.errors.length > 0,
        callback: function ($$v) {
          _vm.$set(_vm.errors, "length > 0", $$v)
        },
        expression: "errors.length > 0",
      },
    },
    [
      _vm.errors.length > 0
        ? _c("div", [
            _vm.errors[0].response.data.validation_errors instanceof Object
              ? _c(
                  "div",
                  [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("Correct the following issues:"))),
                    ]),
                    _vm._v(" "),
                    _c("b-table", {
                      attrs: {
                        items: Object.entries(
                          _vm.errors[0].response.data.validation_errors
                        ),
                        fields: ["field", "problem"],
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "cell(field)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(data.item[0]) +
                                    "\n                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(problem)",
                            fn: function (data) {
                              return [
                                data.item[1] instanceof Object &&
                                Object.entries(data.item[1]).length > 0
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            Object.entries(data.item[1])[0][1]
                                          ) +
                                          "\n                    "
                                      ),
                                    ])
                                  : _c("span", [_vm._v(_vm._s(data.item[1]))]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3907189524
                      ),
                    }),
                  ],
                  1
                )
              : _c("div", [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("HTTP code:")) +
                        " " +
                        _vm._s(_vm.errors[0].response.status)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("code", [
                      _vm._v(
                        _vm._s(JSON.stringify(_vm.errors[0].response.data))
                      ),
                    ]),
                  ]),
                ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }